const validateUrl = (rule, value, callback) => {
  /* eslint-disable */
  const regex = new RegExp(/^(https?:\/\/)((([\da-z\.-]+)\.([a-z\.]{2,6}))|localhost)(:[0-9]+)*([\/\w \.-]*)*\/?$/);
  if (!value) {
    callback(new Error("This field is required"));
  } else if (regex.test(value) === false) {
    callback(new Error("Url is invalid"));
  }else {
    callback();
  }
};

const domainValidation = (rule, value, callback) => {
  /* eslint-disable */
  const regex = new RegExp(/^([a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+)|localhost$/)
  if (!value) {
    callback(new Error("This field is required"));
  } else if (regex.test(value) === false) {
    callback(new Error("Domain name invalid"));
  } else {
    callback();
  }
};

const validateNumber = (rule, value, callback) => {
  if (isNaN(value)){
    callback(new Error("Enter numbers only"));
  } else {
    callback();
  }
};

const validateTin = (rule, value, callback) => {
  /* eslint-disable */
  const regex = new RegExp(/(^[0-9]+[-]*[0-9]+$)/);
  let hypenOnce = false;
  if(value) {
    hypenOnce = value.split('').filter(char => char === '-').length === 1;
  }

  if (!value) {
    callback(new Error("This field is required"));
  } else if (regex.test(value) === false || !hypenOnce) {
    callback(new Error("TIN number invalid"));
  } else {
    callback();
  }
};

export default {
  methods: {
    requiredField () {
      return [ {required: true} ]
    },

    validateField (field) {
      return [
        {
          required: true,
          message: `${field ? field : 'This field'} is required`,
          trigger: 'change'
        }
      ]
    },

    inputField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        }
      ]
    },
    passwordField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          min: 5,
          message: 'Minimum 5 characters long',
          trigger: 'change'
        }
      ]
    },

    validateEmail (field) {
      return [
        {
          required: true,
          message: `${field ? field : 'This field'} is required`,
          trigger: 'change'
        },
        {
          type: 'email',
          message: 'Email address is not valid',
          trigger: 'blur'
        }
      ]
    },

    emailField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          type: 'email',
          message: 'Email address is not valid',
          trigger: ['blur', 'change']
        }
      ]
    },

    urlField () {
      return [{ required: true, validator: validateUrl, trigger: ['blur', 'change'] }];
    },

    domainField () {
      return [{ required: true, validator: domainValidation, trigger: ['blur', 'change'] }];
    },

    bvnField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          validator: validateNumber,
          trigger: 'change'
        },
        {
          min: 11,
          max: 11,
          message: 'Must be 11 digits long',
          trigger: 'change'
        }
      ]
    },

    tinField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          validator: validateTin,
          trigger: 'change'
        }
      ]
    },

    vninField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          min: 16,
          max: 16,
          message: 'Must be 16 digits long',
          trigger: 'change'
        }
      ]
    },

    phoneNumberField () {
      return [
        {
          required: true,
          message: 'This field is required',
          trigger: 'change'
        },
        {
          validator: validateNumber,
          trigger: 'change'
        },
        {
          min: 13,
          max: 13,
          message: 'Must be 13 digits long',
          trigger: 'change'
        }
      ]
    },

    customField (fldType) {
      switch(fldType) {
        case 'bvn/advanced': {
          return this.bvnField();
        }

        case 'nin/phone': {
          return this.phoneNumberField();
        }

        case 'tin': {
          return this.tinField();
        }

        case 'vnin': {
          return this.vninField();
        }

        default: {
          return this.inputField();
        }
      }
    }
  }
}
